(function () {

  let header = document.querySelector('[data-selector="header"]');  
  let burgerBtn = header.querySelector('[data-selector="burger"]');  

  if (burgerBtn && header) {
    burgerBtn.addEventListener('click', function () {
      header.classList.toggle('header_open');
    })
  }

  let menuItemEls = header.querySelectorAll('[data-selector="show-submenu"]');  

  menuItemEls.forEach(function (menuItem) {
    menuItem.addEventListener('click', function () {
      this.parentElement.classList.toggle('header__menu-item-wrap_show')
    });
  });
})();